import React from 'react';
import PropTypes from 'prop-types';
import { getNormalizationFunction } from '../../utils/heatmapFormatUtils';
import { getFormattedValue } from '../../../dashboardUtils';

const legendMaxHeight = 200;
const numberOfTicks = 5;

function getDataValue(max, min, normalizedIndex) {
    return (max - min) * normalizedIndex + min;
}

/* eslint-disable complexity */
function isTickMarkIndex(index, tickAmount, maxHeight) {
    return (
        index === 0 ||
        (index + tickAmount / 2 < maxHeight && index % tickAmount === 0) ||
        index === maxHeight
    );
}
/* eslint-enable complexity */

function getMaxHeight(height) {
    return height > legendMaxHeight ? legendMaxHeight : height;
}

export default function HeatmapLegend({
    getCellColor,
    max,
    min,
    legendHeight,
    legendOffsetTop,
    suffix,
}) {
    const maxHeight = getMaxHeight(legendHeight);
    const cells = [];
    const getNormalizedValue = getNormalizationFunction(0, maxHeight);
    const tickAmount = Math.round(maxHeight / numberOfTicks);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= maxHeight; i++) {
        const normalizedIndex = getNormalizedValue(i);
        const borderColor = getCellColor(normalizedIndex);

        let tickMark = null;
        if (isTickMarkIndex(i, tickAmount, maxHeight)) {
            const dataValue = getDataValue(max, min, normalizedIndex);

            tickMark = (
                <div className="heatmap-legend__tick">
                    {`\u2012${getFormattedValue(dataValue.toFixed(), suffix)}`}
                </div>
            );
        }

        cells.push(
            <div key={i} className="heatmap-legend__cell">
                <div
                    className="heatmap-legend__cell--border"
                    style={{ borderColor }}
                />
                {tickMark}
            </div>
        );
    }

    return (
        <div
            className="heatmap-legend"
            style={{ marginTop: `${legendOffsetTop}px` }}
        >
            {cells}
        </div>
    );
}

HeatmapLegend.propTypes = {
    getCellColor: PropTypes.func.isRequired,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    legendHeight: PropTypes.number.isRequired,
    legendOffsetTop: PropTypes.number.isRequired,
    suffix: PropTypes.string,
};

HeatmapLegend.defaultProps = {
    suffix: '',
};
